/* global axios */
import ApiClient from '../ApiClient';

class CaptainAgentToolAPI extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  list({ assistantId }) {
    return axios.get(`${this.url}/${assistantId}/agent_tools`);
  }

  show({ assistantId, toolId }) {
    return axios.get(`${this.url}/${assistantId}/agent_tools/${toolId}`);
  }

  create({ assistantId, payload }) {
    return axios.post(`${this.url}/${assistantId}/agent_tools`, {
      agent_tool: payload,
    });
  }

  update({ assistantId, toolId, payload }) {
    return axios.patch(`${this.url}/${assistantId}/agent_tools/${toolId}`, {
      agent_tool: payload,
    });
  }

  delete({ assistantId, toolId }) {
    return axios.delete(`${this.url}/${assistantId}/agent_tools/${toolId}`);
  }

  test({ assistantId, toolId, args, conversationId }) {
    return axios.post(`${this.url}/${assistantId}/agent_tools/${toolId}/test`, {
      args,
      conversation_id: conversationId,
    });
  }

  types({ assistantId }) {
    return axios.get(`${this.url}/${assistantId}/agent_tools/types`);
  }
}

export default new CaptainAgentToolAPI();
